import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  
  const breadcrumbMap = {
    '/': 'Etusivu',
    '/palvelut': 'Palvelut',
    '/hinnasto': 'Hinnasto',
    '/yhteystiedot': 'Yhteystiedot'
  };

  const currentPage = breadcrumbMap[location.pathname] || 'Sivu';
  
  // Don't show breadcrumb on home page
  if (location.pathname === '/') {
    return null;
  }

  const breadcrumbStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Etusivu",
        "item": "https://sipelius-kotipalvelu.fi/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": currentPage,
        "item": `https://sipelius-kotipalvelu.fi${location.pathname}`
      }
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbStructuredData)}
        </script>
      </Helmet>
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <div className="container">
          <ol className="breadcrumb-list">
            <li className="breadcrumb-item">
              <Link to="/" className="breadcrumb-link">
                Etusivu
              </Link>
            </li>
            <li className="breadcrumb-separator" aria-hidden="true">
              <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 1L6.5 6L1.5 11" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </li>
            <li className="breadcrumb-item breadcrumb-current" aria-current="page">
              {currentPage}
            </li>
          </ol>
        </div>
      </nav>
    </>
  );
};

export default Breadcrumb;
